export type WithdrawConfirmMode =
  | "none"
  | "fullNameEmail"
  | "firstLastEmail";

export type WithdrawConfirmEmailTarget = "email" | "pixCpf";

export const getWithdrawConfirmMode = (
  countryCode?: string | null
): WithdrawConfirmMode => {
  switch ((countryCode || "").toLowerCase()) {
    case "ci":
      return "fullNameEmail";
    case "sn":
      return "firstLastEmail";
    default:
      return "none";
  }
};

export const getWithdrawConfirmEmailRequired = (
  countryCode?: string | null
): boolean => {
  switch ((countryCode || "").toLowerCase()) {
    case "ci":
      return true;
    default:
      return false;
  }
};

export const getWithdrawConfirmEmailTarget = (
  countryCode?: string | null
): WithdrawConfirmEmailTarget => {
  switch ((countryCode || "").toLowerCase()) {
    case "ci":
      return "pixCpf";
    default:
      return "email";
  }
};
